export default __webpack_public_path__ + "static/media/dropdown-toolbar-variations-1.78f5863a.png";